import './wheel-finder.scss';

import { createElementFromHTML, smoothScrollTo } from '../../js/helper';
import { bindTrackingClick, sendTracking } from '../../js/tracking';

class WheelFinder {
    constructor (element) {
        this.$wheelFinder = element;
        this.$objectsTarget = this.$wheelFinder.querySelector('[data-wheel-finder="objects"]');
        this.$progress = this.$wheelFinder.querySelector('[data-wheel-finder="progress"]');
        this.$copyservice = this.$wheelFinder.querySelector('[data-wheel-finder="copyservice"]');
        this.$infotext = this.$wheelFinder.querySelector('[data-wheel-finder="info"]');
        this.$intro = this.$wheelFinder.querySelector('[data-wheel-finder="intro"]');
        this.$history = this.$wheelFinder.querySelector('[data-wheel-finder="history"]');
        this.$results = this.$wheelFinder.querySelector('[data-wheel-finder="results"]');
        this.$historyChoices = this.$wheelFinder.querySelector('[data-wheel-finder="choices"]');
        this.$historyBack = this.$wheelFinder.querySelector('[data-wheel-finder-history-back]');
        this.$fairFooter = document.querySelector('[data-fair-footer="root"]');
        this.$historyArr = [];
        this.lastID = 0;
        this.baseURL = this.$wheelFinder.querySelector('[data-wheel-finder-base-url]').getAttribute('data-wheel-finder-base-url');
        this.lastURL = this.baseURL;
        this.$loader = createElementFromHTML(window.OPTIONS.loader);
        this.$header = document.querySelector('[data-header="root"]');
        this.resultsActive = false;
        this.isLoading = false;
    }

    initialize () {
        this.setEvents();
        this.setInfotextEvents();
        this.sendPageTracking('wheel-finder|funnel-step|bar-type');
        this.setCopyserviceTrackingEvent();
    }

    sendPageTracking (data) {
        if (data) {
            const trackingArray = data.split('|');

            const trackingData = {};
            trackingData.category = trackingArray[0];
            trackingData.action = trackingArray[1];
            trackingData.label = trackingArray[2];
            trackingData.value = trackingArray[3];

            sendTracking(trackingData);
            console.info('send Trackinginfo: ' + data);
        }
    }

    sendProductTracking () {
        const $$productTitles = this.$results.querySelectorAll('.product-teaser__title');

        $$productTitles.forEach((title) => {
            this.sendPageTracking('wheel-finder|funnel-step|' + title.innerText);
        });

        const $$productLinks = this.$results.querySelectorAll('.product-teaser__link');
        $$productLinks.forEach((link) => {
            link.addEventListener('click', () => {
                this.sendPageTracking('wheel-finder|click-product|result-' + link.previousElementSibling.previousElementSibling.innerText);
            });
        });

        bindTrackingClick(this.$history.querySelector('.nav__button__container.is--dealer'));
        bindTrackingClick(this.$history.querySelector('.nav__button__container.is--restart'));
    }

    setEvents () {
        this.$objectsTarget.addEventListener('click', (e) => {
            let $answer = null;
            if (e.target.getAttribute('data-wheel-finder-answer')) {
                $answer = e.target;
            } else {
                if (e.target.getAttribute('data-wheel-finder') === 'button') {
                    $answer = e.target.parentElement;
                }
            }

            if ($answer && this.isLoading === false) {
                $answer.classList.add('is--selected');
                const url = $answer.getAttribute('data-wheel-finder-answer');
                $answer.querySelector('.wheel-finder__object-button').appendChild(this.$loader);
                this.isLoading = true;

                this.loadNext(url).then((data) => {
                    if (!data.results) {
                        this.nextStep(data);
                        this.scrollToTop();
                        this.setHistory(url, $answer.querySelector('.wheel-finder__object-button').firstElementChild.innerText);
                        this.visibilityActionButtons('hide');

                        setTimeout(() => {
                            this.$loader.parentNode.removeChild(this.$loader);
                        }, 200);
                    } else {
                        this.showResults(data);
                        this.scrollToTop();
                        this.setHistory(url, $answer.querySelector('.wheel-finder__object-button').firstElementChild.innerText);
                        this.visibilityActionButtons('show');
                        this.resultsActive = true;
                    }

                    setTimeout(() => {
                        this.isLoading = false;
                    }, 500);
                });
            }
        });

        this.$history.addEventListener('click', (e) => {
            if (e.target.getAttribute('data-wheel-finder-back') && this.isLoading === false) {
                const url = e.target.getAttribute('data-wheel-finder-back');
                const id = e.target.getAttribute('data-history-id');
                this.isLoading = true;

                if (e.target.localName === 'span') {
                    this.sendPageTracking('wheel-finder|navigation|back');
                }

                if (e.target.localName === 'li') {
                    this.sendPageTracking('wheel-finder|navigation|breadcrumb-' + e.target.firstElementChild.innerText);
                }

                this.loadNext(url).then((data) => {
                    if (this.resultsActive) {
                        this.hideResults();
                        this.nextStep(data);
                        this.changeHistory(id);
                        this.scrollToTop();
                        this.resultsActive = false;
                    } else {
                        this.nextStep(data);
                        this.lastURL = url;
                        this.changeHistory(id);
                        this.scrollToTop();
                    }

                    setTimeout(() => {
                        this.isLoading = false;
                    }, 500);
                });
            }
        });
    }

    scrollToTop () {
        let positionTop = (this.$wheelFinder.getBoundingClientRect().top + window.scrollY) - 2;

        if (this.$header) {
            positionTop = positionTop - this.$header.offsetHeight;
        }
        smoothScrollTo(0, positionTop, 500);
    }

    nextStep (data) {
        this.changeText(data);
        this.changeProgress(data.progress);
        this.changeObjects(() => {
            const $objects = createElementFromHTML(data.objects);

            if ($objects.length > 1) {
                this.$objectsTarget.setAttribute('data-wheel-finder-count', $objects.length);

                $objects.forEach((object) => {
                    object.classList.add('is--hidden');
                    this.$objectsTarget.appendChild(object);

                    setTimeout(() => {
                        object.classList.remove('is--hidden');
                    }, 50);
                });
            } else {
                $objects.classList.add('is--hidden');
                this.$objectsTarget.appendChild($objects);

                setTimeout(() => {
                    $objects.classList.remove('is--hidden');
                }, 50);
            }
            this.isLoading = false;

            if (data.trackinglabel) {
                this.sendPageTracking('wheel-finder|funnel-step|' + data.trackinglabel);
            }
        });
    }

    changeText (data) {
        const $question = this.$wheelFinder.querySelector('[data-wheel-finder="question"]');

        if (data.question) {
            $question.style.height = $question.scrollHeight + 'px';
            $question.classList.add('is--hidden');
            const $newQuestion = document.createElement('span');
            $newQuestion.classList.add('is--hidden');
            $newQuestion.innerHTML = data.question;

            setTimeout(() => {
                $question.appendChild($newQuestion);
                $question.style.height = $newQuestion.scrollHeight + 'px';
                $question.firstElementChild.remove();
                $question.classList.remove('is--hidden');

                setTimeout(() => {
                    $question.style.height = '';
                }, 250);
            }, 500);
        }

        if (data.copyservice) {
            this.showCopyService(data.copyservice);
        } else {
            this.hideCopyService();
        }

        if (data.infotext !== '') {
            this.$infotext.style.height = this.$infotext.scrollHeight + 'px';
            const infoAvailable = this.$infotext.firstElementChild;

            if (infoAvailable) {
                this.$infotext.classList.add('is--hidden');
            }

            const $newInfotext = document.createElement('span');
            $newInfotext.innerHTML = data.infotext;

            setTimeout(() => {
                this.$infotext.appendChild($newInfotext);
                this.$infotext.classList.remove('is--hidden');
                this.$infotext.style.height = this.$infotext.scrollHeight + 'px';

                if (infoAvailable) {
                    this.$infotext.firstElementChild?.remove();
                }

                this.$infotext.classList.remove('is--hidden');

                setTimeout(() => {
                    this.$infotext.style.height = '';
                    this.setInfoTrackingEvent();
                }, 250);
            }, 500);
        } else {
            this.$infotext.style.height = $question.scrollHeight + 'px';
            this.$infotext.classList.add('is--hidden');

            setTimeout(() => {
                this.$infotext.style.height = '0';
                this.$infotext.firstElementChild?.remove();

                setTimeout(() => {
                    this.$infotext.style.height = '';
                }, 250);
            }, 250);
        }
    }

    setInfoTrackingEvent () {
        this.$infotext.addEventListener('click', (e) => {
            if (e.target.getAttribute('data-product-support-overlay')) {
                this.sendPageTracking('wheel-finder|navigation|category-help');
            }
        });
    }

    setCopyserviceTrackingEvent () {
        this.$copyservice.addEventListener('click', (e) => {
            if (e.target.getAttribute('data-glossary')) {
                this.sendPageTracking('wheel-finder|navigation|weight-help');
            }
        });
    }

    showCopyService (value) {
        this.$copyservice.style.height = this.$copyservice.scrollHeight + 'px';
        const $contentAvailable = this.$copyservice.lastElementChild.firstElementChild;

        this.$copyservice.classList.add('is--hidden');

        const $newCopyservice = document.createElement('span');
        $newCopyservice.innerHTML = value;

        setTimeout(() => {
            this.$copyservice.lastElementChild.appendChild($newCopyservice);
            this.$copyservice.classList.remove('is--hidden');
            this.$copyservice.style.height = this.$copyservice.scrollHeight + 'px';

            if ($contentAvailable) {
                this.$copyservice.lastElementChild.firstElementChild?.remove();
            }

            this.$copyservice.classList.remove('is--hidden');

            setTimeout(() => {
                this.$copyservice.style.height = '';
                this.checkForGlossary();
            }, 250);
        }, 500);
    }

    hideCopyService () {
        this.$copyservice.style.height = this.$copyservice.scrollHeight + 'px';

        this.$copyservice.classList.add('is--hidden');

        setTimeout(() => {
            this.$copyservice.style.height = '0';
            this.$copyservice.lastElementChild.firstElementChild?.remove();

            setTimeout(() => {
                this.$copyservice.style.height = '';
            }, 250);
        }, 250);
    }

    changeProgress (progress) {
        if (progress < 50) {
            this.$progress.style.width = 'calc(' + progress + '% + 42px)';
        } else {
            this.$progress.style.width = progress + '%';
        }

        let start = parseInt(this.$progress.firstElementChild.innerText);

        if (start > progress) {
            const setProgress = setInterval(() => {
                this.$progress.firstElementChild.innerText = start + ' %';
                if (start <= progress) {
                    clearInterval(setProgress);
                }
                start--;
            }, (1250 / (start - progress)));
        } else {
            const setProgress = setInterval(() => {
                this.$progress.firstElementChild.innerText = start + ' %';
                if (start >= progress) {
                    clearInterval(setProgress);
                }
                start++;
            }, (1250 / (progress - start)));
        }
    }

    setInfotextEvents () {
        this.$intro.addEventListener('click', (e) => {
            if (e.target.getAttribute('data-product-support-overlay')) {
                e.preventDefault();
                this.initOverlay(e.target);
            }
        });
    }

    changeObjects (callback) {
        const $$objects = this.$objectsTarget.querySelectorAll('[data-wheel-finder="object"]');

        $$objects.forEach((object) => {
            object.classList.add('is--hidden');
            setTimeout(() => {
                object.remove();
            }, 500);
        });

        setTimeout(() => {
            if (typeof callback === 'function') {
                callback();
            }
        }, 500);
    }

    setHistory (url, label) {
        if (this.$history.classList.contains('is--hidden')) {
            if (this.$fairFooter) {
                this.$fairFooter.classList.add('has--history');

                setTimeout(() => {
                    this.showHistory();
                }, 550);

                setTimeout(() => {
                    this.$fairFooter.classList.add('is--visible');
                }, 1500);
            } else {
                this.showHistory();
            }
        }

        this.$historyArr.push({
            id: this.lastID,
            url: this.lastURL,
            label: label
        });

        const entry = '<li class="wheel-finder__choices-item" data-wheel-finder-back="' + this.lastURL + '" data-history-id="' + this.lastID + '"><span>' + label + '</span></li>';
        this.$historyBack.setAttribute('data-wheel-finder-back', this.lastURL);
        this.$historyBack.setAttribute('data-history-id', this.lastID);
        this.$historyChoices.appendChild(createElementFromHTML(entry));
        this.lastID++;
        this.lastURL = url;
    }

    changeHistory (id) {
        id = parseInt(id);

        this.$historyArr.forEach((entry) => {
            if (id > 0 && entry.id === id - 1) {
                this.$historyBack.setAttribute('data-wheel-finder-back', entry.url);
                this.$historyBack.setAttribute('data-history-id', entry.id);
            }

            if (entry.id >= id) {
                this.$historyChoices.querySelector('[data-history-id="' + entry.id + '"]').remove();
            }
        });

        if (id === 0) {
            this.hideHistory();

            this.$historyBack.setAttribute('data-wheel-finder-back', this.baseURL);
            this.$historyBack.setAttribute('data-history-id', 0);
            this.$historyArr = [];
            this.lastURL = this.baseURL;
        } else {
            this.$historyArr.splice(id);
        }
        this.lastID = id;
    }

    hideHistory () {
        this.$history.style.height = this.$history.scrollHeight + 'px';
        this.$history.classList.add('is--hidden');

        if (this.$fairFooter) {
            this.$fairFooter.classList.add('is--hidden');

            setTimeout(() => {
                this.$fairFooter.classList.remove('is--visible');
                this.$fairFooter.classList.remove('has--history');
                this.$fairFooter.classList.remove('is--hidden');
            }, 600);
        }

        setTimeout(() => {
            this.$history.style.height = '';
        }, 500);
    }

    showHistory () {
        this.$history.style.height = this.$history.scrollHeight + 'px';
        this.$history.classList.remove('is--hidden');

        setTimeout(() => {
            this.$history.style.height = '';
        }, 500);
    }

    visibilityActionButtons (status) {
        const $$actionButtons = this.$history.querySelectorAll('.nav__button__container');

        if ($$actionButtons.length > 0) {
            $$actionButtons.forEach((buttonWrap) => {
                if (status === 'show') {
                    buttonWrap.classList.remove('is--wf-hidden');
                }

                if (status === 'hide') {
                    buttonWrap.classList.add('is--wf-hidden');
                }
            });
        }
    }

    showResults (data) {
        const $results = createElementFromHTML(data.products);
        this.hideCopyService();

        if (this.$history.classList.contains('is--hidden')) {
            this.showHistory();
        }

        this.hideProcess(() => {
            this.$results.appendChild($results);
            this.$results.style.height = $results.scrollHeight + 'px';
            this.$results.classList.remove('is--hidden');

            setTimeout(() => {
                this.$results.style.height = '';
                this.initResultsSlider();
                this.sendPageTracking('wheel-finder|funnel-step|result');
                this.sendProductTracking();
            }, 500);
        });
    }

    hideResults () {
        this.$results.style.height = this.$results.scrollHeight + 'px';

        setTimeout(() => {
            this.$results.classList.add('is--hidden');
            this.$results.style.height = '';

            setTimeout(() => {
                this.$results.firstElementChild.remove();
                this.showProcess();
            }, 500);
        }, 50);
    }

    hideProcess (callback) {
        this.$intro.style.height = this.$intro.scrollHeight + 'px';
        this.$intro.classList.add('is--hidden');

        this.$objectsTarget.style.height = this.$objectsTarget.scrollHeight + 'px';
        this.$objectsTarget.classList.add('is--hidden');

        if (typeof callback === 'function') {
            this.$intro.style.height = '';
            this.$objectsTarget.style.height = '';

            setTimeout(() => {
                callback();
            }, 500);
        }
    }

    showProcess () {
        this.$intro.style.height = this.$intro.scrollHeight + 'px';
        this.$objectsTarget.style.height = this.$objectsTarget.scrollHeight + 'px';
        this.$intro.classList.remove('is--hidden');
        this.$objectsTarget.classList.remove('is--hidden');

        setTimeout(() => {
            this.$intro.style.height = '';
            this.$objectsTarget.style.height = '';
        }, 250);
    }

    initResultsSlider () {
        import('../product-overview-slider/product-overview-slider').then(({ ProductOverviewSlider }) => {
            const $productOverviewSlider = this.$results.querySelector('[data-productoverview="slider"]');

            if ($productOverviewSlider) {
                const productOverviewSlider = new ProductOverviewSlider($productOverviewSlider);
                productOverviewSlider.initialize();
            }
        });
    }

    initOverlay ($overlayLink) {
        import('../../modules/product-support/product-support-overlay').then(({ ProductSupportOverlay }) => {
            const openLinkAPI = new ProductSupportOverlay($overlayLink, {
                loader: window.OPTIONS.loader
            });
            openLinkAPI.callOverlay($overlayLink);
        });
    }

    checkForGlossary () {
        const $$glossaries = this.$copyservice.querySelectorAll('[data-glossary]');
        if ($$glossaries.length > 0) {
            import('../../components/glossary/glossary').then(({ Glossary }) => {
                for (let i = 0; i < $$glossaries.length; i++) {
                    const $glossary = $$glossaries[i];

                    const glossaryAPI = new Glossary($glossary, {
                        loader: window.OPTIONS.loader
                    });
                    $glossary.API = glossaryAPI;
                }
            });
        }
    }

    loadNext (url) {
        return new Promise((resolve, reject) => {
            fetch(url, {
                headers: {
                    'X-Requested-With': 'XMLHttpRequest',
                    'Content-Type': 'application/json'
                }
            }).then(data => {
                resolve(data.json());
            }).catch((response) => {
                reject(new Error(response));
            });
        });
    }
}

export { WheelFinder };

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    if ($context) {
        const $wheelFinder = $context.querySelector('[data-wheel-finder="root"]');

        if ($wheelFinder) {
            const wheelFinder = new WheelFinder($wheelFinder);
            wheelFinder.initialize();
        }
    }
});
